import { useContext } from "react";
import DadosEstoqueContext from "../context/dadosEstoqueContext";

const useDadosContextEstoque = () => useContext(DadosEstoqueContext);

export default useDadosContextEstoque;
